import {
  commonMutationTypes,
  OrderDirection,
  pageInfo,
  userDetails,
} from "../../../../../../utils/commonQueryTypes";
import { AtsStckItem } from "../../../masters/items/queries/types";
import { AtsMrfMstOrderField } from "../../material/queries/types";

export enum AtsRfqTrnOrderField {
  CREATED_AT = "CREATED_AT",
  SL_NO = "SL_NO",
  TRN_DATE = "TRN_DATE",
  TRN_NEED_BEFORE = "TRN_NEED_BEFORE",
}
export enum AtsRfqMstOrderField {
  CREATED_AT = "CREATED_AT",
  MRF_NO = "MRF_NO",
  RFQ_DATE = "RFQ_DATE",
  START_DATE = "START_DATE",
  CLOSE_DATE = "CLOSE_DATE",
  COMPR_START_DATE = "COMPR_START_DATE",
  COMPR_CLOSE_DATE = "COMPR_CLOSE_DATE",
  COMPR_MADE_DATE = "COMPR_MADE_DATE",
  NEGO_START_DATE = "NEGO_START_DATE",
  NEGO_CLOSE_DATE = "NEGO_CLOSE_DATE",
  NEGO_MADE_DATE = "NEGO_MADE_DATE",
}

export interface rfqPendingItemType {
  id: number;
  udfItemDesc: string;
  uom: string;
  presentStk: number;
  approxRate: number;
  acceptQty: number;
  taxable: number;
  tax: number;
  trnNeedBefore: string;
  priority: string;
  item: {
    id: number;
    desc: string;
    code: string;
  };
}
interface EmpDetails {
  name: string;
}
interface AtsMrfMst {
  id: number;
  mrfNo: string;
  mrfDate: string;
  subsidiary: {
    id: number;
    name: string;
  };
  rfqPendingItems: rfqPendingItemType[];
  raisedByUserDetails: EmpDetails;
  acceptedByUserDetails: EmpDetails;
}

export interface AtsMrfMstForRfqsEdge {
  node: AtsMrfMst;
  cursor: string;
}

interface GetMrfsData {
  edges: AtsMrfMstForRfqsEdge[];
  pageInfo: pageInfo;
  totalCount: number;
}

export interface GetMrfsForRFQsResult {
  GetMrfs: GetMrfsData;
}

interface CreateRfqItemList {
  slNo: number;
  udfItemDesc: string;
  trnQty: number;
  approxRate: number;
  priority: string;
  trnNeedBefore: string;
  itemTerms: string;
  itemPaymentTerms: string;
  itemRemarks: string;
  mrfTrnSlNo: number;
  itemID: number;
  mrfTrnID: number;
  mrfID: number;
  preferredSupplierIds: string;
}
interface CreateRfq {
  rfqDate: string;
  rfqNo: string;
  remarks: string;
  lastDateRfqSubmission: string;
  generalTerms: string;
  generalPaymentTerms: string;
  itemsList: CreateRfqItemList[];
}

export interface AddRfqVars {
  token?: string;
  customerId: number;
  finYrId: number;
  user_details: userDetails;

  input: CreateRfq;
}

export interface AddRfqResult {
  AddRfq: boolean;
}

export interface EmpMaster {
  id: number;
  name: string;
}

export interface AtsRfqMst {
  id: number;
  rfqNo: string;
  rfqDate: string;
  itemQty: number;
  totalQty: number;
  remarks: string;
  lastDateRfqSubmission: string;
  comprMadeDate: string;
  raisedByUserID: string;
  comprRemarks: string;
  completed: boolean;
  comprMadeByID: string;
  rfqTrnDetails: AtsRfqTrn[];
  raisedUserDetails: EmpMaster;
  comprUserDetails: EmpMaster;
  negoUserDetails: EmpMaster;
}

export interface AtsRfqMstEdge {
  node: AtsRfqMst;
  cursor: string;
}

interface GetRfqsData {
  edges: AtsRfqMstEdge[];
  pageInfo: pageInfo;
  totalCount: number;
}

export interface GetRfqsResult {
  GetRfqs: GetRfqsData;
}

export enum RfqQueryType {
  ALL = "ALL",
  PENDING = "PENDING",
  IN_PROGRES = "IN_PROGRES",
  COMPLETED = "COMPLETED",
}

export interface GetRfqsVars {
  token?: string;
  after: string | null;
  first: number | null;
  finYrId: number;
  customerId: number;
  start_date: string;
  end_date: string;
  queryType: RfqQueryType;
  orderBy: {
    direction: OrderDirection;
    field: AtsRfqMstOrderField;
  };
  name: string;
}

export interface subsidiaryType {
  id: number;
  name: string;
}

export interface SupplierType {
  id: number;
  desc: string;
  supplier_details: {
    id: number;
    gstNo: string;
    panNo: string;
    city: string;
    supplier_name: {
      desc: string;
    };
  };
}
export interface ItemType {
  id: number;
  desc: string;
  code: string;
  uom: string;
}
export interface AtsMrfTrn {
  priority: any;
  id: number;
  mrfNo: string;
  mrfDate: string;
  udfItemDesc: string;
  presentStk: number;
  approxRate: number;
  approxDlvryRate: number;
  approxInstRate: number;
  approxOtherRate: number;
  acceptQty: number;
  taxable: number;
  reqQty: number;
  tax: number;
  item: ItemType;
  trnNeedBefore: string;
  mrf: AtsMrfMst;
  preferedSupplierDetails: SupplierType[];
}
export interface AtsRfqTrn {
  slNo: number;
  itemTerms: string;
  itemPaymentTerms: string;
  itemRemarks: string;
  approxRate: number;
  trnQty: number;
  preferedSupplierDetails: SupplierType[];
  item: AtsStckItem;
  mrf_trn_details: AtsMrfTrn;
}

export interface AtsRfqMstData {
  rfqNo: string;
  rfqDate: string;
  remarks: string;
  lastDateRfqSubmission: string;
  rfqTrnDetails: AtsRfqTrn[];
}

export interface UpdateRfqVars extends AddRfqVars {
  rfqId: number;
}

export interface UpdateRfqResult {
  UpdateRfq: boolean;
}

export interface AtsRfqTrn {
  id: number;
  udfItemDesc: string;
  mrf_trn_details: AtsMrfTrn;
  itemTerms: string;
  itemPaymentTerms: string;
  itemRemarks: string;
  rfq: {
    lastDateRfqSubmission: string;
    rfqNo: string;
    remarks: string;
  };
  preferedSupplierDetails: SupplierType[];
  trnQty: number;
}

export interface AtsRfqTrnEdge {
  node: AtsRfqTrn;
  cursor: string;
}

export interface GetRfqTrnsResult {
  GetRfqTrnsFromSupplierId: {
    edges: AtsRfqTrnEdge[];
    pageInfo: pageInfo;
    totalCount: number;
  };
}

export interface GetRfqTrnSupplyResult {
  GetRfqTrnSupply: {
    id: number;
    rfq: {
      lastDateRfqSubmission: string;
      rfqNo: string;
      remarks: string;
      generalTerms: string;
      generalPaymentTerms: string;
    };
    rfqTrn: {
      udfItemDesc: string;
      reqQty: number;
      remarks: string;
      itemTerms: string;
      itemPaymentTerms: string;
      preferedSupplierDetails: {
        id: number;
        desc: string;
        supplier_details: {
          city: string;
          gstNo: string;
          panNo: string;
        };
      }[];
    };
    supplierDetails: {
      id: number;
      desc: string;
      supplier_details: {
        city: string;
        gstNo: string;
      };
    };
  }[];
}
export interface GetRfqTrnSupplyVars {
  rfqTrnID: string;
  ldgrID: string;
}

export interface AddRfqTrnSupplyResult {
  AddRfqTrnSupply: boolean;
}
export interface CreateRfqTrnSupply {
  slNo: number;
  rfqTrnSlNo: number;
  isAccepted: boolean;
  itemDescChanged: boolean;
  quotedDesc: string;
  quotedQty: number;
  quotedRate: number;
  quotedOther: number;
  quotedTaxable: number;
  quotedTax: number;
  quotedDelvChrg: number;
  quotedInstChrg: number;
  quotedValue: number;
  quotedRemarks: string;
  quotedProductBrochure: string;
  itemID: number;
  rfqTrnID: number;
  quotedAnyChanges: boolean;
}

export interface AddRfqTrnSupplyVar {
  ldgrID: number;
  input: CreateRfqTrnSupply[];
}
export interface DeleteRfqResult {
  DeleteRfqResult: boolean;
}

export interface DeleteRfqVar extends commonMutationTypes {
  customerId: number;
  finYrId: number;
  rfqId: number;
}

export interface SendEmailToSuppliersResult {
  SendEmailToSuppliers: boolean;
}

export interface SendEmailToSuppliersVars {
  token?: string;
  customerId: number;
  finYrId: number;
  rfqId: number;
  user_details: userDetails;
}

export interface AtsRfqTrnSupply {
  id: number;
  rfq: {
    lastDateRfqSubmission: string;
    rfqNo: string;
    remarks: string;
    generalTerms: string;
    generalPaymentTerms: string;
  };
  ldgrID: number;
  rfqTrn: {
    id: number;
    udfItemDesc: string;
    remarks: string;
    itemTerms: string;
    itemPaymentTerms: string;
    mrf_trn_details: {
      reqQty: number;
      remarks: string;
    };
    preferedSupplierDetails: {
      id: number;
      desc: string;
      supplier_details: {
        city: string;
        gstNo: string;
        panNo: string;
      };
    }[];
  };
  supplierDetails: {
    id: number;
    desc: string;
    supplier_details: {
      city: string;
      gstNo: string;
      panNo: string;
    };
  };
}

export interface AtsRfqTrnSupplyQuotationDetails extends AtsRfqTrnSupply {
  itemDescChanged: boolean;
  isAccepted: boolean;
  quotedAnyChanges: boolean;
  quotedDesc: string;
  quotedQty: number;
  quotedRate: number;
  quotedTax: number;
  quotedDelvChrg: number;
  quotedInstChrg: number;
  quotedValue: number;
  quotedRemarks: string;
  quotedOther: number;
  quotedCompleted: boolean;
  negoQty: number;
  negoRate: number;
  negoStatus: boolean;
  negoOther: number;
  negoTaxable: number;
  negoTax: number;
  negoDelvChrg: number;
  negoInstChrg: number;
  negoValue: number;
  negoRemarks: string;
}
export interface GetRfqTrnSupplyByKeyForQuotationDetailsResult {
  GetRfqTrnSupplyByKey: AtsRfqTrnSupplyQuotationDetails[];
}
export interface GetRfqTrnSupplyByKeyResult {
  GetRfqTrnSupplyByKey: AtsRfqTrnSupply[];
}

export interface GetRfqTrnSupplyByKeyVar {
  key: string;
}

export interface CheckIfQuoteSubmittedResult {
  CheckIfQuoteSubmitted: boolean;
}

export interface UpdateRfqTrnSupplyQuoteResult {
  UpdateRfqTrnSupplyQuote: boolean;
}

export interface UpdateRfqTrnSupplyQuoteVars {
  uuid: string;
  input: {
    rfqTrnSupplyId: number;
    isAccepted: boolean;
    itemDescChanged: boolean;
    quotedAnyChanges: boolean;
    quotedDesc: string;
    quotedQty: number;
    quotedRate: number;
    quotedOther: number;
    quotedTaxable: number;
    quotedTax: number;
    quotedDelvChrg: number;
    quotedInstChrg: number;
    quotedValue: number;
    quotedRemarks: string;
    quotedProductBrochure: string;
  }[];
}

export interface SubmitQuotationResult {
  SubmitQuotation: boolean;
}

export interface SubmitQuotationVars {
  uuid: string;
}
